<template>
  <div class="page__content not-found">
    <section class="error-404">
      <div class="container">
        <article class="card">
          <div class="card-content">
            <h1>404</h1>
            <p>{{ $t("generic.pageNotFound") }}</p>
          </div>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
    export default {
        name: 'no-found',
    };
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/pages/not-found/not-found.vue